module.exports = __webpack_public_path__ + "static/media/aam-parenthood.0ef4c3eb.jpg";